export { default } from './DailyTimeRecordIndiaMorocco.js';